const KR = {
  common: {
    email: '이메일',
    password: '비밀번호',
    login: '로그인',
    signUp: '회원가입',
    name: '이름 (예시: 홍길동)',
    nickname: '닉네임',
    birthYear: '생년',
    sex: '성별',
    edu: '학력',
    education: {
      middle: '중졸',
      high: '고졸',
      college: '전문대졸',
      university: '대졸',
      graduate: '대학원졸',
      attending: '대학 재학중',
    },
    confirm: '확인',
    cancel: '취소',
    close: '닫기',
  },
  error: {
    title: '문제가 발생했습니다!',
    undefined: '관리자에게 문의 바랍니다.',
    notEnoughQuest: '한명이 문제를 다 풀지 않았습니다.',
    invalid: {
      email: '잘못된 이메일 형식 입니다.',
      duplicateEmail: '이미 가입된 이메일 입니다.',
      password: '비밀번호는 8글자 이상 입력하셔야 합니다.',
      nickname: '올바른 닉네임을 입력해 주세요.',
      duplicateNickname: '이미 사용 중인 닉네임 입니다.',
      name: '이름을 입력해 주세요.',
      birth: '생년을 선택해 주세요.',
      sex: '성별을 선택해 주세요.',
      education: '학력을 선택해 주세요.',
      tag: '직종을 선택해 주세요.',
      auth: '아이디 또는 비밀번호를 확인해주세요.',
      emoji: '이모티콘은 입력하실 수 없습니다.',
      clientId: '올바르지 않은 ID 입니다.',
    },
    trackingProtection: `
      현재 접속하신 브라우저에선<br>
      서비스 일부 기능에<br>
      제한이 있을 수 있습니다.<br>
      쾌적한 TEAManity 이용을 위해<br>
      다른 브라우저를 이용하여<br>
      주시기 바랍니다.`,
    snsAuthFailed: '인증에 실패하였습니다.',
    consentProvideEmail: '이메일 정보 제공에 동의해주셔야 합니다.',
    isNotTestPeriod: '테스트 기간이 아닙니다.',
    notFound: {
      title: '404 Not Found',
      message: '페이지를 찾을 수 없습니다.',
    },
    tooLongGroupName: '그룹 이름은 20자를 넘길 수 없습니다.',
  },
  intro: {
    description1: `
      <h1>나에게는 어떤 일이 어울릴까?</h1>
      <span>뇌적성 검사로 찾아보는 나의 숨은 잠재력!
      TEAManity를 통해 당신의 진정한 모습을 확인해보세요.</span>`,
    description2: `
      <h1>나에게 어울리는 최고의 파트너는?</h1>
      <span>뇌적성 검사를 통해 나의 강점을 살려주고
      약점은 보완해주는 파트너를 확인해 볼 수 있어요.</span>`,
    description3: `
      <h1>최고의 팀을 만들어보세요!</h1>
      <span>팀 속에서 자신이 해야 할 역할을 잘 파악하는 사람은
      최고의 성과를 만들어냅니다.
      뇌적성 검사로 성향을 파악하여
      지금 바로 최고의 팀을 결성해보세요!</span>`,
    next: '다음',
    start: '시작하기',
  },
  acc: {
    login: {
      title: 'Silicon Valley Teaming Network <br> 팀을 매칭하는 가장 좋은 방법',
      signUpByEmail: '이메일로 회원가입',
      findPassWord: '비밀번호 찾기',
      curAccountLogin: '기존 계정으로 로그인',
      terms: '<div>회원가입시 <router-link to="/terms/privacy">개인정보 취급방침</router-link>과<br><router-link to="/terms/service">서비스 이용약관</router-link>에 동의합니다.</div>',
    },
    signUp: {
      occupation: '직종 (다중선택가능)',
      necessary: '* 위의 항목은 모두 필수항목입니다.',
      pwHolder: '비밀번호 (8자 이상)',
      sex: {
        man: '남성',
        woman: '여성',
      },
      sns: {
        title: '회원 정보 입력',
        facebook: 'Facebook 로그인 완료',
        kakao: 'KaKao 로그인 완료',
        naver: 'Naver 로그인 완료',
        idRequired: '소셜 회원가입은 해당 서비스 로그인을 이용해서만 가능합니다.',
      },
      terms: {
        title: '약관 동의 절차',
        service: '서비스 이용 약관 동의',
        privacy: '개인정보 수집 동의',
        checkbox: '동의합니다. <span>(필수)</span>',
        modal: '약관에 동의해주세요.',
      },
    },
    delete: {
      header: '회원탈퇴',
      title: '비밀번호 확인',
      content: '회원탈퇴를 위해 비밀번호를<br>한 번 더 입력해 주세요.',
      comment: '탈퇴시 3개월간 동일 계정으로<br>재가입이 불가능합니다.',
      placeholder: '비밀번호',
      button: '탈퇴하기',
      modalBody: '비밀번호가 틀렸습니다.',
      done: {
        title: '회원탈퇴 완료',
        content1: '회원님의 탈퇴가<br>정상적으로 이루어졌습니다.',
        content2: '그 동안 저희 서비스를<br>이용해 주셔서 감사합니다.',
        button: '확인',
      },
    },
    detail: {
      header: '내 계정',
      headerLeft: '취소',
      headerRight: '완료',
      name: '이름',
      nickname: '닉네임',
      email: '이메일',
      birth: '출생년도',
      education: '학력',
      jobs: '직종',
      delete: '회원탈퇴',
      completed: '프로필을 수정하였습니다.',
    },
    done: {
      content: '축하합니다!<br>이제 TEAManity를 사용할 수 있습니다.',
      button: '시작하기',
    },
    findPw: {
      header: '비밀번호 찾기',
      content: 'TEAManity<br>팀을 매칭하는 가장 좋은 방법',
      holder: '이메일',
      button: '비밀번호 재설정 링크 전송',
      result: '이메일을 전송하였습니다.',
    },
  },
  myMenu: {
    editProfile: '프로필 편집',
    myReport: '내 보고서',
    myRole: '팀내 나의 역할',
    language: '언어설정',
    customerCenter: '고객센터',
    notice: '공지사항',
    faq: 'FAQ',
    contactUs: '문의하기',
    logout: '로그아웃',
    logoutBody: '로그아웃 하시겠습니까?',
    terms: '<div><router-link to="/terms/privacy">개인정보 취급방침</router-link> 및 <router-link to="/terms/service">서비스 이용약관</router-link> 보기</div>',
    modalHeader: '테스트 미완료',
    modalBody: '테스트 완료 후 보고서 열람이 가능합니다.<br>임시 저장된 테스트를 불러오시겠습니까?',
    anonymous: '익명',
    notification: '알림',
  },
  match: {
    listHeader: '매칭하기/리스트',
    friend: '친구',
    group: '그룹',
    resultHeader: '매칭률',
    name: '이름',
    nickname: '닉네임',
    email: '이메일',
    birth: '출생년도',
    education: '학력',
    jobs: '직종',
    more: '더보기',
    spreader: '열정적인 \'전파자\'',
    stargazer: '창의적인 \'몽상가\'',
    structuralDesigner: '엄격한 \'구조설계자\'',
    productPlanner: '현실적인 \'상품기획자\'',
    expert: '냉철한 \'독설가\'',
    executive: '완벽한 \'실행가\'',
    qr: {
      header: '내 QR 코드',
      message1: '친구가 당신을 추가할 수 있도록<br>아래의 QR 코드를 공유하세요.',
      message2: '위 코드를 스캔하면<br>TEAManity에서 매칭률을 확인할 수 있습니다.',
      message3: '그룹에 초대할 수 있도록<br>아래의 QR 코드를 공유하세요.',
      button: 'QR 스캔하기',
    },
    qrScan: {
      header: 'QR 코드 스캔',
      message: '위 화면의 QR 코드를 인식하면<br>자동으로 친구 등록이 됩니다.',
    },
    makeGroupPlaceholder: '그룹 이름을 입력해주세요',
    inviteMember: '그룹원 초대',
    myFriend: '내 친구',
    expelMember: '그룹원 내보내기',
    delegationLeader: '그룹장 위임',
    addGroupDone: '그룹에 추가 되었습니다.',
  },
  report: {
    mine: '내 보고서',
    roleHeader: '팀내 나의 역할',
    title: 'Idea 역할 점수 분포',
    content: '자신이 팀내에서 어떤 역할이 더 잘 맞는지 볼 수 있습니다.',
    ideation: {
      short: '몽상가',
      title: '창의적인 \'몽상가\'',
      content: '새로운 아이디어를 내거나 새로운 컨셉을 기획할 수 있는 역량. 대개는 우뇌의 창의성이 좋은 사람이 새로운 발상과 아이디어를 제시하는 능력이 좋습니다.',
    },
    multiplier: {
      short: ' 전파자',
      title: '열정적인 \'전파자\'',
      content: '아이디어를 다른 사람과 공유하거나 조직 속에서 빠른 속도로 확산시키는 역량. 조직 속에 사회성이 좋은 사람이 다른 사람의 아이디어를 잘 받아들이고 전달하는 속도가 빠릅니다.',
    },
    solution: {
      short: '구조설계',
      title: '엄격한 \'구조설계자\'',
      content: '초기 아이디어를 더욱 정교하게 구조화하고, 더 나아가 문제에 대한 구체적인 솔루션까지 만들어내는 역량. 좌뇌의 순차적 사고가 좋은 사람이 아이디어를 구조화시키는 능력이 좋습니다.',
    },
    judgement: {
      short: '상품기획자',
      title: '현실적인 \'상품기획자\'',
      content: '추상적인 아이디어가 제대로 현실에 뿌리내릴 수 있도록 방향을 잡거나 판단을 내리는 역량. 우뇌의 직관이 좋은 사람이 아이디어에 대한 판단 능력이 탁월합니다.',
    },
    execution: {
      short: ' 실행가 ',
      title: '완벽한 \'실행가\'',
      content: '아이디어를 구체적인 성과로 연결할 수 있는 역량. 아무리 좋은 아이디어도 실행력이 뒷받침되지 않으면 소용이 없습니다. 대개 완벽주의적 성향을 가진 사람 가운데 실행력이 뛰어난 경우가 많습니다.',
    },
    critic: {
      short: ' 독설가 ',
      title: '냉철한 \'독설가\'',
      content: '아이디어가 가지고 있는 문제점을 발견하고, 미래에 발생할 수 있는 리스크 요인까지 솔직하게 지적할 수 있는 역량. 우뇌성향인데 논리가 강한 사람이 아이디어를 비판하는 능력이 좋습니다.',
    },
    veryGood: '매우 좋다',
    good: '좋다',
    soso: '보통이다',
    bad: '안좋다',
    veryBad: '매우 안좋다',
  },
  tabMenu: {
    home: '홈',
    report: '내 보고서',
    friend: '매칭하기',
    matching: '매칭리스트',
  },
  friends: {
    title: '친구 추가',
    kakao: '카카오톡',
    urlAdd: 'URL 복사',
    qr: '내 QR 코드',
    groupQr: '그룹 QR 코드',
    qrScan: 'QR 코드 스캔',
    btnOK: '확인',
    btnClose: '닫기',
    share: 'MC6 공유로<br>최고의 팀을 꾸려보세요!',
    shareBtn: '공유하기',
    facebook: '페이스북으로 공유',
    url: 'URL로 공유',
    urlCopy: '링크가 클립보드에<br>복사되었습니다',
  },
  test: {
    intro: {
      header: '검사하기',
      title: '팀 구성 / 역할 테스트',
      content1: '검사 시간은 15분 정도 소요되며, 제출 후 다시 풀기는 불가능합니다.',
      content2: '마음에 들지 않는 질문이 있더라도 솔직하게 답해주세요.',
      content3: '답변 수정은 직전 한 문제까지만 가능합니다.',
      button: '시작하기',
    },
    question: {
      header: '테스트',
      headerRight: '임시저장',
      stronglyAgree: '매우 그렇다',
      agree: '그런편이다',
      disagree: '그렇지 않다',
      stronglyDisagree: '매우 그렇지 않다',
      // minimum: '최소 6문제 이상은 푸셔야 합니다.',
    },
    done: {
      header: '검사 완료',
      content: '테스트를 완료하였습니다.',
      button: '홈으로 가기',
    },
  },
  mc6: {
    info: '검사를 모두 마친 뒤<br>나의 매직서클을 확인해보세요!',
    friends: {
      done: '친구 추가가 완료되었습니다.',
    },
  },
  terms: {
    title: {
      privacy: '개인정보 취급방침',
      service: '서비스 이용약관',
    },
  },
  share: {
    title: '[TEAManity]',
    desc: 'TEAManity에서 자신의 성향을 알아보고 주변인들과의 매칭률을 확인해보세요.',
    addDesc: '뇌적성 검사로 나의 숨은 잠재력을 찾아보세요!',
    imgUrl: 'https://api.teamanity.app:11604/files/meta/mc6-share.jpg',
  },
  matchManage: {
    title: '매칭 리스트 관리',
    inviteFriend: '친구 초대',
    makeGroup: '그룹 생성',
  },
  groupManage: {
    title: '그룹 관리',
    invite: '그룹원 초대',
    expel: '내보내기',
    delegation: '그룹장 위임',
    secession: '그룹 탈퇴',
    secessionMsg: '그룹에서 탈퇴 하시겠습니까?',
  },
};

export default KR;



// WEBPACK FOOTER //
// ./src/constants/i18n/kr.js